export class BreakpointWidthConstants {
  public static readonly PERSISTENT_SIDE_NAV_WIDTH: string = '(min-width: 1024px)';
  public static readonly NON_PERSISTENT_SIDE_NAV_WIDTH: string = '(max-width: 0px)';
  public static readonly BOTTOM_TABS_WIDTH: string = '(max-width: 1024px)';
  public static readonly MEDIUM_VIEW_WIDTH: string = '(max-width: 1536px)'
  public static readonly MEDIUM_VIEW_MIN_SIDE_MENU_WIDTH: string = '(max-width: 1381px)'
  public static readonly MEDIUM_VIEW_NO_SIDE_MENU_WIDTH: string = '(max-width: 1299px)'
  public static readonly SMALL_VIEW_WIDTH: string = '(max-width: 768px)'
  public static readonly MODAL_WIDTH: string = '(max-width: 600px)'
}
